import { Spinner } from 'summon-ui'
import { useTranslation } from 'summon-ui/intl'
import { Center, Group, Stack } from 'summon-ui/mantine'
import useRedeemables from '@features/home/hooks/useRedeemables'
import { ClaimableItemType } from '@generated/generates'
import useClaim from '../../../hooks/useClaim'
import NoItemsMessage from '../NoItemsMessage'
import Claimable from './Claimable'
import Redeemable from './Reedemable'

const NO_CLAIMABLES_TITLE = 'No Claimables Available'
const NO_CLAIMABLES_SUBTITLE =
  'Claimables are unlocked when you complete certain quests, missions, or attend special events. Keep questing and stay involved'

const Claimables = () => {
  const t = useTranslation()
  const { claimableItems, isLoading, claimablesItemsStatus } = useClaim(ClaimableItemType.Tier)
  const { rewardsRedeemables, rewardsRedeemablesStatus } = useRedeemables()
  const hasClaimableItems = claimableItems?.some((claimable) => claimable.isUsed === false)
  const hasRedeemables = rewardsRedeemables && rewardsRedeemables?.length > 0

  if (isLoading) {
    return (
      <Center className='h-80'>
        <Spinner />
      </Center>
    )
  }

  if (claimablesItemsStatus === 'error' || rewardsRedeemablesStatus === 'error') {
    return <Center className='h-80'>Something wrong happened...</Center>
  }

  return (
    <Stack h='100%' mt='md'>
      {hasClaimableItems || hasRedeemables ? (
        <Group>
          {rewardsRedeemables?.map(({ id, units, title, imageUrl, rewardIntegration }) => {
            const isSponsored = rewardIntegration?.additionalData?.isSponsored
            return (
              <Redeemable
                key={id}
                redeemableId={id}
                units={units}
                title={title}
                imageUrl={imageUrl}
                isSponsored={isSponsored}
              />
            )
          })}

          {claimableItems?.map(({ id, isUsed, nonce, signature, randomData, data }) => {
            return !isUsed ? (
              <Claimable
                key={id}
                id={id}
                nonce={nonce}
                signature={signature}
                randomData={randomData}
                isMainnet={data?.isMainnet}
              />
            ) : null
          })}
        </Group>
      ) : (
        <NoItemsMessage title={t(NO_CLAIMABLES_TITLE)} message={t(NO_CLAIMABLES_SUBTITLE)} />
      )}
    </Stack>
  )
}

export default Claimables
